export const tableStyles = "w-fit max-w-max min-w-[60%] border-collapse border-b border-solid border-black bg-white";
export const titleStyles = "text-center py-4 lg:p-4 box-border";
export const secondaryTitleStyles = "text-left pl-4 py-4 lg:p-4 box-border";
export const rowStyles = "border-t border-l border-r border-solid border-black";
export const rowAltStyles = "bg-light-grey";
export const cellStyles = "p-2 lg:p-4 box-border";
export const valueStyles = "text-center font-default";
